import { render, staticRenderFns } from "./AddDevice.vue?vue&type=template&id=b60bf032&scoped=true&"
import script from "./AddDevice.vue?vue&type=script&lang=js&"
export * from "./AddDevice.vue?vue&type=script&lang=js&"
import style0 from "./AddDevice.vue?vue&type=style&index=0&id=b60bf032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60bf032",
  null
  
)

export default component.exports